// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".carousel__slide--visible[data-v-27224174] {\n  transform: rotateY(0);\n}\n", ""]);
// Exports
module.exports = exports;
